import {createContext, FC, ReactNode, useMemo} from 'react';

export type LayoutType = 'sideBySide' | 'stacked';
export const LayoutContext = createContext<{type: LayoutType} | null>(null);

export const LayoutProvider: FC<{children: ReactNode; type: LayoutType}> = ({
    children,
    type,
}) => {
    const value = useMemo(() => ({type}), [type]);
    return (
        <LayoutContext.Provider value={value}>
            {children}
        </LayoutContext.Provider>
    );
};
